export default __webpack_public_path__ + "static/media/erasmussardaigne2.6acfd10a.png";